// DOCUMENTATION: https://mui.com/customization/theming/

import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0052cc',
    },
    secondary: {
      main: '#edf2ff',
    },
    // error: {},
    // warning: {},
    // info: {},
    // success: {},
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: 'small',
        variant: 'contained',
      },
    },
  },
  // typography: {},
  // spacing: {},
  // breakpoints: {},
  // zIndex: {},
  // transitions: {},
});

export default theme;

